module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('modal', {
    attrs: {
      "show": _vm.show
    },
    on: {
      "onShow": function($event) {
        _vm.$emit('onShow')
      },
      "onHide": function($event) {
        _vm.$emit('onHide')
      }
    }
  }, [_c('div', {
    staticClass: "dialog-hd"
  }, [_c('h4', {
    staticClass: "dialog-title"
  }, [_vm._v(_vm._s(_vm.title))])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-bd"
  }, [_c('div', {
    staticClass: "dialog-msg-container"
  }, [_vm._t("default")], 2)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-ft"
  }, [_c('a', {
    staticClass: "dialog-btn primary",
    attrs: {
      "href": "javascript:;"
    },
    on: {
      "click": _vm.onConfirm
    }
  }, [_vm._v(_vm._s(_vm.confirmText))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2ac4faff!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modal/alert.vue
// module id = 342
// module chunks = 1